import React, { useEffect, useState } from 'react';
import { closeModal } from '../../../app/modals/redux/modalActions';
import { connect } from 'react-redux';
import TextInput from '../../../app/common/form/TextInput';
import TextArea from '../../../app/common/form/TextArea';
import { reduxForm, Field } from 'redux-form';
import Modal from '../../../ui/Modal';
import Icon from '@mdi/react';
import { mdiCalendarOutline } from '@mdi/js';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';

function mapState(state) {
  let auth = state.auth;
  let scope = auth?.isAuth ? auth.authorities : {};
  let loading = state.async.loading;

  return {
    auth,
    scope,
    loading,
  };
}

const actions = {
  closeModal,
};

function ModalViewEvent(props) {
  const { data, closeModal, handleSubmit } = props;
  const [definput, setDefinput] = useState({});
  const screenWidth = useScreenWidth();

  useEffect(() => {
    let event = data && data.item && data.item.id ? data.item : null;
    if (event) {
      setDefinput({ ...definput, ...event });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeName = (e) => {};

  const onFormSubmit = (values) => {};

  return (
    <Modal
      variant='info'
      label='noLabel'
      noBorder={true}
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <div className='flex justify-between align-center is-size-5 py-4 px-4'>
        <span className='flex align-center has-text-info has-text-weight-semibold'>
          <span className='icon is-medium'>
            <Icon path={mdiCalendarOutline} size={1} />
          </span>
          <span>Calendar Detail</span>
        </span>
      </div>
      <div style={{ borderBottom: '1px solid #e5e7eb' }}></div>
      <form
        className='py-5 px-5'
        onSubmit={handleSubmit(onFormSubmit)}
        autoComplete='off'
      >
        <Field
          label='Judul Event'
          name='subject'
          type='text'
          component={TextInput}
          placeholder='Judul Event'
          defaultValue={definput.subject}
          onChange={(e) => onChangeName(e)}
          readOnly={true}
        />
        <Field
          label='Tipe'
          name='type'
          type='text'
          component={TextInput}
          placeholder='Tipe'
          fullwidth={true}
          defaultValue={definput.type}
          onChange={(e) => onChangeName(e)}
          readOnly={true}
        />
        {definput.allDayEvent && (
          <Field
            label='All Day Event'
            name='allDayEvent'
            type='text'
            component={TextInput}
            placeholder='All Day Event'
            fullwidth={true}
            defaultValue={definput.allDayEvent === true ? 'Yes' : 'No'}
            onChange={(e) => onChangeName(e)}
            readOnly={true}
          />
        )}
        {definput.allDayEvent && definput.type === 'event' && (
          <>
            <Field
              label={!definput.endDate ? 'Tanggal' : 'Mulai'}
              name='dateStart'
              type='text'
              component={TextInput}
              placeholder={!definput.endDate ? 'Tanggal' : 'Mulai'}
              fullwidth={true}
              defaultValue={definput.startDate}
              onChange={(e) => onChangeName(e)}
              readOnly={true}
            />
            {definput.endDate && (
              <Field
                label='Berakhir'
                name='dateEnd'
                type='text'
                component={TextInput}
                placeholder='Berakhir'
                fullwidth={true}
                defaultValue={definput.endDate}
                onChange={(e) => onChangeName(e)}
                readOnly={true}
              />
            )}
          </>
        )}
        {!definput.allDayEvent && (
          <div className='field is-horizontal'>
            <div className='field-body'>
              <Field
                label='Mulai'
                name='dateStart'
                type='text'
                component={TextInput}
                placeholder='Mulai'
                fullwidth={true}
                defaultValue={definput.startDate + ' ' + definput.startTime}
                onChange={(e) => onChangeName(e)}
                readOnly={true}
              />
              <Field
                label='Berakhir'
                name='dateEnd'
                type='text'
                component={TextInput}
                placeholder='Berakhir'
                fullwidth={true}
                defaultValue={definput.endDate + ' ' + definput.endTime}
                onChange={(e) => onChangeName(e)}
                readOnly={true}
              />
            </div>
          </div>
        )}
        {definput.type === 'libur' && (
          <div className='field is-horizontal'>
            <div className='field-body'>
              <Field
                label={!definput.endDate ? 'Tanggal' : 'Mulai'}
                name='dateStart'
                type='text'
                component={TextInput}
                placeholder={!definput.endDate ? 'Tanggal' : 'Mulai'}
                fullwidth={true}
                defaultValue={definput.startDate}
                onChange={(e) => onChangeName(e)}
                readOnly={true}
              />
              {definput.endDate && (
                <Field
                  label='Berakhir'
                  name='dateEnd'
                  type='text'
                  component={TextInput}
                  placeholder='Berakhir'
                  fullwidth={true}
                  defaultValue={definput.endDate}
                  onChange={(e) => onChangeName(e)}
                  readOnly={true}
                />
              )}
            </div>
          </div>
        )}
        <Field
          label='Deskripsi'
          name='description'
          type='text'
          component={TextArea}
          placeholder='Deskripsi'
          fullwidth={true}
          readOnly={true}
        />
      </form>
      {/* </div> */}
      {/* </div> */}
    </Modal>
  );
}

export default connect(
  mapState,
  actions
)(reduxForm({ form: 'calendarViewEventModal' })(ModalViewEvent));
